// =====================================================================
// ZENTRALE INHALTSDATEI — Freiwillige Feuerwehr Dingharting
// Alle Texte, Zahlen und Bildpfade an einer Stelle bearbeitbar.
// Bilder liegen unter /public/assets/final/ und können ersetzt werden.
// =====================================================================

export const site = {
  name: "Freiwillige Feuerwehr Dingharting",
  shortName: "FF Dingharting",
  jahre: "152",
  seit: "1874",
  anlass: "Fahrzeugweihe 2026",
  flyerPdf: "/assets/pdf/feuerwehr-dingharting-flyer.pdf",
  website: "www.feuerwehr-dingharting.de",
  websiteUrl: "https://www.feuerwehr-dingharting.de",
  mitgliedUrl: "https://www.feuerwehr-dingharting.de/mitglied-werden",
};

export const nav = [
  { label: "Start", href: "#hero" },
  { label: "Grußworte", href: "#grussworte" },
  { label: "Geschichte", href: "#geschichte" },
  { label: "TLF 3000 St", href: "#tlf-3000" },
  { label: "Fuhrpark", href: "#fuhrpark" },
  { label: "Mannschaft", href: "#team" },
  { label: "Jugend", href: "#jugend" },
  { label: "Mitglied werden", href: "#mitglied" },
];

export const hero = {
  kicker: "Gegründet 1874",
  titleLines: ["Feuerwehr", "Dingharting"],
  subline: "Fahrzeugweihe 2026 — Weihe des neuen TLF 3000 St",
  intro:
    "Seit 1874 im Dienst der Gemeinschaft. Ein Rückblick auf über 150 Jahre Kameradschaft, Mut und Fortschritt — und ein Ausblick auf unsere Zukunft.",
  image: "/assets/final/hero-rescue.png",
};

export const grussworte = {
  title: "Grußworte",
  subtitle: "Stimmen aus Wehr und Verein",
  entries: [
    {
      name: "Martin Lambertz · Markus Bucher",
      role: "Kommandant · stellv. Kommandant",
      image: "/assets/final/portrait-lambertz-bucher.png",
      quote:
        "Über 150 Jahre Freiwillige Feuerwehr Dingharting — das ist gelebte Kameradschaft.",
      text:
        "Wir bedanken uns bei der Gemeinde, den Förderern und unseren benachbarten Feuerwehren für ihre Unterstützung und die stets gute Zusammenarbeit.",
    },
    {
      name: "Moritz Leserer",
      role: "1. Vorsitzender",
      image: "/assets/final/portrait-leserer.png",
      quote:
        "Mit Stolz blicken wir auf das Erbe unserer Wehr und auf das neue Fahrzeug. Getragen wird all das vom Zusammenhalt und vom Ehrenamt in unserem Dorf.",
      text:
        "Ohne die Unterstützung der Bevölkerung und den unermüdlichen Einsatz vieler Freiwilliger wäre dies nicht möglich. Dafür sagen wir von Herzen Dank.",
    },
  ],
};

export const geschichte = {
  title: "Technische Entwicklung",
  subtitle: "Von der Eimerkette zum Tanklöschfahrzeug",
  intro:
    "Seit Menschen sesshaft wurden, gehörten Brände zu den größten Gefahren für Dörfer und Städte. Die technische Entwicklung unserer Feuerwehr spiegelt diesen Wandel über mehr als 150 Jahre eindrucksvoll wider.",
  chapters: [
    {
      no: "01",
      jahr: "1874",
      title: "Die Gründung",
      text:
        "Gegründet nach dem Deutsch-Französischen Krieg im Zuge des verbesserten ländlichen Brandschutzes in Bayern. Joseph Faßl wird erster Vorsitzender, 52 Männer treten bei.",
      image: "/assets/final/history-founding.png",
    },
    {
      no: "02",
      jahr: "~1881",
      title: "Erste Spritze",
      text:
        "Die erste Spritze befand sich noch auf einem Pferdegespann. Sie wurde ab ca. 1881 genutzt und blieb bis 1955 im Dienst.",
      image: "/assets/final/history-horse.png",
    },
    {
      no: "03",
      jahr: "1946",
      title: "Erste Motorpumpe",
      text:
        "Dingharting bekam die erste motorbetriebene Pumpe. Sie stammte aus der ehemaligen Munitionsanstalt Föhrenwald.",
      image: "/assets/final/history-pump.png",
    },
    {
      no: "04",
      jahr: "1955 – 1972",
      title: "Motorisierung",
      text:
        "Tragkraftspritzenanhänger (1955), Aggregat (1962) und das LF 8 (1972) — die Wehr wird Schritt für Schritt schlagkräftiger.",
      image: "/assets/final/history-tsa.png",
    },
    {
      no: "05",
      jahr: "1978",
      title: "TLF 8",
      text:
        "Einweihung des ersten Tanklöschfahrzeugs TLF 8 (links)",
      image: "/assets/final/history-lf8-old.png",
    },
  ],
};

export const statistics = {
  title: "Die Wehr in Zahlen",
  items: [
    { value: 152, suffix: "", label: "Jahre im Dienst" },
    { value: 30, suffix: "+", label: "Aktive Mitglieder" },
    { value: 1239, suffix: "", label: "Einwohner im Einsatzgebiet" },
    { value: 40, suffix: " km²", label: "Einsatzgebiet" },
    { value: 33, suffix: " %", label: "Atemschutzträger" },
    { value: 26, suffix: "", label: "Einsätze pro Jahr" },
  ],
  einsatzgebiet: "Großdingharting · Holzhausen · Kleindingharting · Ebertshausen",
};

export const tlf3000 = {
  badge: "NEU 2026",
  title: "TLF 3000 St",
  subtitle: "Tanklöschfahrzeug",
  intro:
    "Unser neues Tanklöschfahrzeug — eine Investition in die Sicherheit der kommenden Jahrzehnte. Es ersetzt das 37 Jahre alte TLF 8/18.",
  image: "/assets/final/vehicle-tlf3000.png",
  specs: [
    { label: "Baujahr", value: "2026" },
    { label: "Fahrgestell", value: "MAN TGM 18.320" },
    { label: "Leistung", value: "220 kW" },
    { label: "Besatzung", value: "1 / 5" },
    { label: "Pumpe", value: "FPN 10-2000" },
    { label: "Löschmittel", value: "3.000 l Wasser & 120 l Schaum" },
    { label: "Aufbau", value: "Lentner" },
    { label: "Sonderausstattung", value: "Seilwinde · tragbarer Monitor · Pump & Roll · fest verbauter Schaumzumischer" },
  ],
};

export const fuhrpark = {
  title: "Unser Fuhrpark",
  subtitle: "Fahrzeuge im Dienst & ihre Vorgänger",
  vehicles: [
    { name: "TLF 3000 St (MAN TGM 18.320)", jahre: "seit 2026", image: "/assets/final/vehicle-tlf3000.png" },
    { name: "TLF 8/18 (MAN 8.136)", jahre: "1989 – 2026", image: "/assets/final/vehicle-tlf818.png" },
    { name: "LF 8/6 THL (MAN L 2000)", jahre: "seit 2001", image: "/assets/final/vehicle-lf86.png" },
    { name: "LF 8 (Opel Blitz)", jahre: "1972 – 2001", image: "/assets/final/vehicle-lf8.png" },
  ],
};

export const einsatzchronik = {
  title: "Einsatzchronik",
  subtitle: "Vom Brand zur technischen Hilfeleistung",
  intro:
    "Über die Jahrzehnte hat sich das Einsatzgeschehen deutlich gewandelt — von überwiegend Brandeinsätzen hin zu technischer Hilfeleistung und wetterbedingten Lagen.",
  images: [
    "/assets/final/fire-building.png",
    "/assets/final/incident-1.png",
    "/assets/final/incident-4.png",
    "/assets/final/incident-2.png",
    "/assets/final/incident-3.png",
    "/assets/final/demo-fire.png",
  ],
  vergleich: [
    { jahr: "1997", brand: 72, thl: 28, einsaetze: 12, stunden: 69 },
    { jahr: "2024", brand: 35, thl: 65, einsaetze: 26, stunden: 120 },
  ],
  ereignisse: [
    { jahr: "1884", text: "Erste dokumentierte Brandbekämpfung im Ort" },
    { jahr: "1932", text: "Brand beim Neuwirt Seidl (Großdingharting)" },
    { jahr: "1953", text: "Stadlbrand Niedermair (Großdingharting)" },
    { jahr: "1982", text: "Großbrand bei Peroxid (Höllrigelskreuth)" },
    { jahr: "1993", text: "Waldbrand bei Straßlach" },
    { jahr: "1994", text: "Blitzeinschlag im Herzl Anwesen (Straßlach)" },
    { jahr: "2019", text: "Jahrhunderthochwasser — tagelanger Einsatz" },
    { jahr: "2020", text: "Unterstützung in der COVID-19 Teststation" },
    { jahr: "2020", text: "Brand eines Feldstadls in Oberbiberg - Gerblingshausen" },
    { jahr: "2024", text: "2x überörtliche Hilfeleistung im Lkr. Pfaffenhofen und Baar/ Ebenhausen" },
  ],
};

export const team = {
  title: "Unsere Mannschaft",
  subtitle: "Über 30 aktive Kameradinnen und Kameraden",
  text:
    "Mehr als 30 aktive Feuerwehrleute stehen bereit, wenn Hilfe gebraucht wird — zuverlässig, kompetent und oft unter schwierigen Bedingungen. 33 % der Mannschaft sind ausgebildete Atemschutzgeräteträger.",
  images: {
    main: "/assets/final/team-church.png",
    group: "/assets/final/team-group.png",
  },
};

export const jugend = {
  title: "Jugendfeuerwehr Dingharting",
  subtitle: "Der Nachwuchs unserer Wehr",
  text:
    "Wir, die Jugendgruppe der FF Dingharting, sind stolz, Teil der 152-jährigen Geschichte zu sein. Ab 12 Jahren werden hier alle Grundlagen gelegt — Teamgeist und Köpfchen sind dabei ebenso wichtig wie Strahlrohrführung oder Erste Hilfe.",
  cta: {
    headline: "Lust dabei zu sein?",
    text: "Sprich uns gerne an oder schreibe uns eine E-Mail an:",
    email: "jugend@feuerwehr-dingharting.de",
    uebung: "Alle 2–3 Wochen, außerhalb der Schulferien, 18:30 – 20:30 Uhr (am Gerätehaus)",
    eintritt: "Ab 12 Jahren (mit Einverständnis der Eltern) · ab 16 Jahren aktive Mannschaft möglich",
  },
  images: ["/assets/final/youth-1.png", "/assets/final/youth-2.png", "/assets/final/youth-3.png"],
};

export const vereinsleben = {
  title: "Vereinsleben & Engagement",
  subtitle: "Mehr als nur Einsatz",
  intro:
    "Die Feuerwehr ist ein lebendiger Teil des Dorflebens — bei Festen, Feiern und im Miteinander der Gemeinschaft.",
  events: [
    { name: "Tag der offenen Tür", image: "/assets/final/community-2.png" },
    { name: "Kirta-Feier, Umzüge & Feste", image: "/assets/final/community-3.png" },
    { name: "Brandwache Sonnwendfeuer", image: "/assets/final/community-1.png" },
  ],
};

export const mitglied = {
  kicker: "Werde Teil unserer Gemeinschaft",
  title: "Mitglied werden",
  text:
    "Offen für alle Altersgruppen und Hintergründe — ganz gleich, ob mit oder ohne Vorerfahrung. Ob im aktiven Dienst oder als förderndes Mitglied: Jede Unterstützung zählt.",
  primaryLabel: "Antrag herunterladen",
};

export const footer = {
  name: "Freiwillige Feuerwehr Dingharting e.V.",
  responsible: "Vertreten durch:",
  board: "Moritz Leserer, 1. Vorstand",
  commander: "Martin Lambertz, 1. Kommandant",
  adresse: "Am Weiher 1, 82064 Großdingharting",
  telefon: "08170 996454",
  telefonHinweis: "Gerätehaus nur zeitweise besetzt",
  email: "verein@feuerwehr-dingharting.de",
  website: "www.feuerwehr-dingharting.de",
  websiteUrl: "https://www.feuerwehr-dingharting.de",
  impressum: "Freiwillige Feuerwehr Dingharting e.V. · Am Weiher 1 · 82064 Großdingharting",
};
